import Logger from './Logger';

export const console = Logger;
